<div class="mx-auto max-w-7xl px-4">
    <!-- En-tête -->
    <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
        <h1 class="text-3xl font-bold mb-2 text-gray-800">Gérer les Prédictions Unitaires</h1>
        <p class="text-gray-600">Traitez les demandes de prédictions personnalisées des utilisateurs</p>
    </div>

    <!-- Statistiques rapides -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow p-6">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-yellow-500 rounded-md flex items-center justify-center">
                        <i class="pi pi-clock text-white"></i>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500">En attente</p>
                    <p class="text-2xl font-semibold text-gray-900">{{ stats().pending }}</p>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-lg shadow p-6">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-blue-500 rounded-md flex items-center justify-center">
                        <i class="pi pi-cog text-white"></i>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500">En cours</p>
                    <p class="text-2xl font-semibold text-gray-900">{{ stats().processing }}</p>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-lg shadow p-6">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-green-500 rounded-md flex items-center justify-center">
                        <i class="pi pi-check text-white"></i>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500">Terminées</p>
                    <p class="text-2xl font-semibold text-gray-900">{{ stats().completed }}</p>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-lg shadow p-6">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-purple-500 rounded-md flex items-center justify-center">
                        <i class="pi pi-dollar text-white"></i>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500">Revenus</p>
                    <p class="text-2xl font-semibold text-gray-900">{{ stats().totalRevenue }} jetons</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Filtres -->
    <div class="bg-white shadow rounded-lg p-6 mb-8">
        <div class="flex flex-wrap gap-4 items-center">
            <div class="flex-1 min-w-64">
                <label class="block text-sm font-medium text-gray-700 mb-1">Statut</label>
                <p-dropdown [(ngModel)]="statusFilter" [options]="statusOptions" optionLabel="label" optionValue="value"
                    placeholder="Filtrer par statut" styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="flex-1 min-w-64">
                <label class="block text-sm font-medium text-gray-700 mb-1">Sport</label>
                <p-dropdown [(ngModel)]="sportFilter" [options]="sportOptions" optionLabel="label" optionValue="value"
                    placeholder="Filtrer par sport" styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="flex-1 min-w-64">
                <label class="block text-sm font-medium text-gray-700 mb-1">Date du match</label>
                <p-calendar [(ngModel)]="dateFilter" dateFormat="dd/mm/yy" placeholder="Filtrer par date"
                    styleClass="w-full">
                </p-calendar>
            </div>

            <div class="flex items-end gap-2">
                <p-button icon="pi pi-search" label="Filtrer" (onClick)="applyFilters()" styleClass="p-button-primary">
                </p-button>
                <p-button icon="pi pi-times" label="Effacer" (onClick)="clearFilters()" styleClass="p-button-outlined">
                </p-button>
            </div>
        </div>
    </div>

    <!-- Table des demandes -->
    <div class="bg-white shadow rounded-lg overflow-hidden">
        <div class="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h2 class="text-lg font-semibold text-gray-900">
                Demandes de Prédictions ({{ getFilteredRequests().length }})
            </h2>
            <div class="flex gap-2">

                <p-button icon="pi pi-refresh" (onClick)="refreshData()" [loading]="isLoading()"
                    styleClass="p-button-outlined p-button-sm" pTooltip="Actualiser">
                </p-button>
            </div>
        </div>

        <p-table [value]="getFilteredRequests()" [loading]="isLoading()" responsiveLayout="scroll" [paginator]="true"
            [rows]="10" [showCurrentPageReport]="true"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} demandes" [rowHover]="true">

            <ng-template pTemplate="header">
                <tr>
                    <th>ID</th>
                    <th>Utilisateur</th>
                    <th>Match demandé</th>
                    <th>Sport</th>
                    <th>Date du match</th>
                    <th>Statut</th>
                    <th>Demandé le</th>
                    <th>Prix</th>
                    <th>Actions</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-request>
                <tr>
                    <!-- ID -->
                    <td class="text-sm font-medium text-gray-900">#{{ request.id }}</td>
                    <!-- Utilisateur -->
                    <td>
                        <div class="flex items-center">
                            <div class="flex-shrink-0 h-10 w-10">
                                <div class="h-10 w-10 rounded-full bg-blue-500 flex items-center justify-center">
                                    <span class="text-white font-medium text-sm">
                                        {{ request.user_name?.substring(0, 2).toUpperCase() }}
                                    </span>
                                </div>
                            </div>
                            <div class="ml-4">
                                <div class="text-sm font-medium text-gray-900">{{ request.user_name }}</div>
                                <div class="text-sm text-gray-500">{{ request.user_email }}</div>
                            </div>
                        </div>
                    </td>

                    <!-- Match -->
                    <td>
                        <div class="text-sm font-medium text-gray-900">
                            {{ request.requested_team_home_name }} vs {{ request.requested_team_away_name }}
                        </div>
                        <div class="text-sm text-gray-500">{{ request.requested_competition_name }}</div>
                    </td>

                    <!-- Sport -->
                    <td>
                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                            [ngClass]="getSportClass(request.requested_sport_name)">
                            <i class="pi pi-circle-fill mr-1" style="font-size: 6px;"></i>
                            {{ request.requested_sport_name }}
                        </span>
                    </td>

                    <!-- Date du match -->
                    <td class="text-sm text-gray-900">
                        {{ request.requested_event_date | date:'dd/MM/yyyy' }}
                    </td>

                    <!-- Statut -->
                    <td>
                        <p-tag [value]="getStatusLabel(request.status)" [severity]="getStatusSeverity(request.status)">
                        </p-tag>
                    </td>

                    <!-- Date de demande -->
                    <td class="text-sm text-gray-500">
                        {{ request.purchase_date | date:'dd/MM/yyyy - HH:mm' }}
                    </td>

                    <!-- Prix -->
                    <td class="text-sm font-medium text-gray-900">
                        {{ request.price_credits }} jetons
                    </td>

                    <!-- Actions -->
                    <td>
                        <div class="flex items-center gap-2">
                            <!-- Voir détails -->
                            <p-button icon="pi pi-eye" (onClick)="viewRequestDetails(request)"
                                styleClass="p-button-outlined p-button-sm" pTooltip="Voir détails">
                            </p-button>

                            <!-- Actions selon le statut -->
                            <ng-container [ngSwitch]="request.status">
                                <!-- En attente -->
                                <ng-container *ngSwitchCase="'pending'">
                                    <p-button icon="pi pi-play" (onClick)="markAsProcessing(request)"
                                        styleClass="p-button-outlined p-button-info p-button-sm"
                                        pTooltip="Marquer en cours">
                                    </p-button>
                                    <p-button icon="pi pi-pencil" (onClick)="startProcessing(request)"
                                        styleClass="p-button-outlined p-button-success p-button-sm"
                                        pTooltip="Créer prédiction">
                                    </p-button>
                                </ng-container>

                                <!-- En cours -->
                                <ng-container *ngSwitchCase="'processing'">
                                    <p-button icon="pi pi-upload" (onClick)="startProcessing(request)"
                                        styleClass="p-button-outlined p-button-success p-button-sm"
                                        pTooltip="Finaliser prédiction">
                                    </p-button>
                                </ng-container>

                                <!-- Terminé -->
                                <ng-container *ngSwitchCase="'completed'">
                                    <p-button icon="pi pi-check"
                                        styleClass="p-button-outlined p-button-secondary p-button-sm" [disabled]="true"
                                        pTooltip="Terminé">
                                    </p-button>
                                </ng-container>

                                <!-- Annulé -->
                                <ng-container *ngSwitchCase="'cancelled'">
                                    <p-button icon="pi pi-times"
                                        styleClass="p-button-outlined p-button-danger p-button-sm" [disabled]="true"
                                        pTooltip="Annulé">
                                    </p-button>
                                </ng-container>
                            </ng-container>

                            <!-- Annuler (seulement si pas terminé) -->
                            <p-button *ngIf="request.status !== 'completed' && request.status !== 'cancelled'"
                                icon="pi pi-trash" (onClick)="cancelRequest(request)"
                                styleClass="p-button-outlined p-button-danger p-button-sm" pTooltip="Annuler demande">
                            </p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8" class="text-center py-8">
                        <i class="pi pi-inbox text-4xl text-gray-300 mb-4"></i>
                        <p class="text-gray-500">Aucune demande trouvée</p>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Dialog de création de prédiction -->
    <p-dialog [(visible)]="showPredictionFormDialog" [modal]="true" [draggable]="false" [resizable]="false"
        [style]="{ width: '90vw', maxWidth: '800px' }"
        [header]="'Créer une prédiction pour ' + selectedRequest?.user_name">

        <div *ngIf="selectedRequest" class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h4 class="font-semibold text-blue-800 mb-2">Détails de la demande</h4>
            <div class="grid grid-cols-2 gap-4 text-sm">
                <div><strong>Match :</strong> {{ selectedRequest.requested_team_home_name }} vs {{
                    selectedRequest.requested_team_away_name }}</div>
                <div><strong>Sport :</strong> {{ selectedRequest.requested_sport_name }}</div>
                <div><strong>Date :</strong> {{ selectedRequest.requested_event_date | date:'dd/MM/yyyy - HH:mm' }}
                </div>
            </div>
        </div>

        <app-prediction-form [teams]="teams()" [sports]="sports()" [competitions]="competitions()"
            (formSubmit)="onPredictionCreated($event)">
        </app-prediction-form>

        <div *ngIf="customErrors.dateError" class="text-red-500 text-sm text-center">
            La date ne peut pas être dans le passé.
        </div>
        <div *ngIf="customErrors.isEqualTeams" class="text-red-500 text-sm text-center">
            Les équipes ne doivent pas être les mêmes
        </div>
    </p-dialog>

    <!-- Dialog de détails -->
    <p-dialog [(visible)]="showDetailsDialog" [modal]="true" [draggable]="false" [resizable]="false"
        [style]="{ width: '600px' }" [header]="'Détails de la demande #' + selectedRequest?.id">

        <div *ngIf="selectedRequest" class="space-y-4">
            <!-- Info utilisateur -->
            <div class="border-b pb-4">
                <h4 class="font-semibold mb-2">Informations utilisateur</h4>
                <div class="grid grid-cols-2 gap-4 text-sm">
                    <div><strong>Nom :</strong> {{ selectedRequest.user_name }}</div>
                    <div><strong>Email :</strong> {{ selectedRequest.user_email }}</div>
                    <div><strong>ID utilisateur :</strong> {{ selectedRequest.user_id }}</div>
                    <div><strong>Statut :</strong>
                        <p-tag [value]="getStatusLabel(selectedRequest.status)"
                            [severity]="getStatusSeverity(selectedRequest.status)" styleClass="ml-2">
                        </p-tag>
                    </div>
                </div>
            </div>

            <!-- Info match -->
            <div class="border-b pb-4">
                <h4 class="font-semibold mb-2">Détails du match</h4>
                <div class="grid grid-cols-2 gap-4 text-sm">
                    <div><strong>Équipe domicile :</strong> {{ selectedRequest.requested_team_home_name }}</div>
                    <div><strong>Équipe extérieur :</strong> {{ selectedRequest.requested_team_away_name }}</div>
                    <div><strong>Sport :</strong> {{ selectedRequest.requested_sport_name }}</div>
                    <div><strong>Compétition :</strong> {{ selectedRequest.requested_competition_name }}</div>
                    <div><strong>Date :</strong> {{ selectedRequest.requested_event_date | date:'dd/MM/yyyy - HH:mm' }}
                    </div>
                    <div><strong>Prix payé :</strong> {{ selectedRequest.price_credits }} jetons</div>
                </div>
            </div>

            <!-- Info demande -->
            <div>
                <h4 class="font-semibold mb-2">Informations de la demande</h4>
                <div class="grid grid-cols-2 gap-4 text-sm">
                    <div><strong>Demandé le :</strong> {{ selectedRequest.purchase_date | date:'dd/MM/yyyy - HH:mm' }}
                    </div>
                    <div *ngIf="selectedRequest.prediction_id"><strong>ID Prédiction :</strong> {{
                        selectedRequest.prediction_id }}</div>
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <p-button label="Fermer" icon="pi pi-times" (onClick)="showDetailsDialog = false"
                styleClass="p-button-text">
            </p-button>
        </ng-template>
    </p-dialog>

    <p-dialog header="Confirmer l'annulation" [(visible)]="cancelDialogVisible" modal [closable]="false">
        <p>Êtes-vous sûr de vouloir annuler la demande de <strong>{{ selectedRequest?.user_name }}</strong> ?</p>

        <textarea rows="3" [(ngModel)]="cancelNote" placeholder="Ajouter une note (optionnel)"
            class="p-inputtext p-component p-filled p-mt-3 p-mb-3" style="width: 100%;"></textarea>

        <ng-template pTemplate="footer">
            <button pButton type="button" label="Garder" (click)="cancelDialogVisible = false"
                class="p-button-text"></button>
            <button pButton type="button" label="Annuler la demande" (click)="confirmCancel()"
                class="p-button-danger"></button>
        </ng-template>
    </p-dialog>

    <!-- Toast pour les notifications -->
    <p-toast   [position]="isMobile ? 'bottom-center' : 'top-right'" />

    <!-- Dialog de confirmation -->
    <p-confirmDialog></p-confirmDialog>
</div>